import { render, staticRenderFns } from "./pendingtrial.vue?vue&type=template&id=00d989bd&scoped=true&"
import script from "./pendingtrial.vue?vue&type=script&lang=js&"
export * from "./pendingtrial.vue?vue&type=script&lang=js&"
import style0 from "./pendingtrial.vue?vue&type=style&index=0&id=00d989bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d989bd",
  null
  
)

export default component.exports